module.exports = __webpack_public_path__ + "img/logo-union-login.c128cd78.png";